import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const SalesStatusInput = () => {
  const { statusId = '' } = useParams();
  const decodedId = statusId ? atob(statusId) : statusId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'salesStatus';

  useEffect(() => {
    if (statusId) {
      setIsEditing(true);
      fetchStatusDetails();
    }
  }, [statusId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchStatusDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.salesStatus}${id}/`, { headers });
      const d = response.data;
      setFormData({
        ...d,
        customer: d.customer?.id ?? d.customer,
        stage: d.stage?.id ?? d.stage,
      });
    } catch (error) {
      console.error('Error fetching sales status details:', error);
    }
  };

  const statusFields = [
    { name: 'status_description', label: 'Status Description', type: 'textarea' },
    {
      name: 'customer', label: 'Customer', type: 'async-select', required: true,
      endpoint: API_ROUTES.customer,
      getOptionLabel: (c) => c.name,
    },
    {
      name: 'stage', label: 'Sales Stage', type: 'async-select', required: true,
      endpoint: API_ROUTES.salesStage,
      getOptionLabel: (s) => s.name,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Sales Status' : 'Create Sales Status'}</h1>
      <FormComponent fields={statusFields} initialFormData={formData} route={route} cancelPath="/customer/sales-status/list" />
    </div>
  );
};

export default SalesStatusInput;
